module.exports = __webpack_public_path__ + "img/About_b1.59503248.png";